'use client';

import Link from 'next/link';
import { useSession } from 'next-auth/react';

import Icon from '../ui/Icon';

const OuraLogo = () => (
  <Icon
    icon="OURA_WORD_MARK"
    color="helsinki-blue-dark"
    height={29}
    width={93}
    variant="glyph"
  />
);

/**
 * Hook-free so it can render on pages that deliberately sit outside the
 * provider tree, such as the maintenance-mode interstitial.
 */
export const ErrorPageNavigationBar = ({
  linkToHome,
}: {
  readonly linkToHome: boolean;
}) => (
  <nav className="container h-[60px] py-4 desktop:h-[80px]" role="navigation">
    <ul className="flex h-full items-center gap-10">
      <li>
        {linkToHome ? (
          <Link passHref href="/">
            <OuraLogo />
          </Link>
        ) : (
          <OuraLogo />
        )}
      </li>
    </ul>
  </nav>
);

const ErrorPageNavigation = () => {
  const session = useSession();
  const data = session.data;
  const isBuyer = data?.roles.includes('buyer') ?? false;

  return <ErrorPageNavigationBar linkToHome={!isBuyer} />;
};

export default ErrorPageNavigation;
